import React, { useState, useEffect } from "react";
import { ArrowLeft, Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import ProductSelectModal from "../pharmacy/pharmacymodels/ProductSelectModal";
import CreateNewProduct from "./CreateNewProduct";
import PurchaseForm from "../pharmacy/PurchaseForm";
import ProductTable from "../pharmacy/ProductTable";
import DiscountChargeSection from "../pharmacy/DiscountChargeSection";
import TotalsBar from "../pharmacy/TotalsBar";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAddPurchaseMutation } from "../../State/Api/AddPurchaseApiSlice";
import { useLazyGetPurchaseDetailsQuery } from "../../State/Api/PharmacyOrderApiSlice";
import DistributorSelectModal from "./pharmacymodels/DistributorSelectModal";
import PurchasePaymentModal from "./pharmacymodels/PurchasePaymentModel";
import { useParams } from "react-router-dom";

const PurchaseOrder = () => {
  const navigate = useNavigate();

  const { pharmaId, purchaseId } = useParams();

  const isEdit = Boolean(purchaseId);

  const PharmaId = localStorage.getItem("userUniqueID");

  const [addPurchase, { isLoading }] = useAddPurchaseMutation();

  const [triggerGetDetails, { data: purchaseDetails }] =
    useLazyGetPurchaseDetailsQuery();

  useEffect(() => {
    if (isEdit) {
      triggerGetDetails({ pharmaId, purchaseId });
    }
  }, [isEdit, pharmaId, purchaseId]);

  useEffect(() => {
    if (purchaseDetails && isEdit) {
      formik.setValues({
        purchaseType: purchaseDetails.billType,
        billHasGST: purchaseDetails.hasGst ? "Yes" : "No",
        distributerId: purchaseDetails.distributerId,
        distributorName: purchaseDetails.distributorName,
        invoiceNo: purchaseDetails.invoiceNum,
        invoiceDate: purchaseDetails.invoiceDate,
        paymentDueDate: purchaseDetails.paymentDueDate,
        overallDiscount: purchaseDetails.billDiscount,
        customCharge: purchaseDetails.customCharge,
      });

const mappedProducts = purchaseDetails.products.map((p) => {
  console.log("Mapping product:", p);

  // Split scheme string
  const [scheme, bonus] = p.schemeName?.split("+") ?? ["", ""];

  return {
    purProdId: p.purProdID,             
    productId: p.productID,             
    productBarcode: p.productName,
    batchId: p.batchID,                
    hsn: p.hsn || "NA",
    expiry: p.expiry,                   
    pack: p.numOfPacks,
    qty: p.quantity,
    free: p.isSampleFree,
    mrp: p.mrp,
    rate: p.rate,
    scheme: scheme,
    schemeBonus: bonus,
    schPercent: p.schemeDiscPercent,
    disc: p.normalDiscPercent,
    gst: p.gstPercent,                   // Updated
    margin: p.marginPercent,
    amount: p.productAmount,
  };
});


      setProducts(mappedProducts);
    }
  }, [purchaseDetails]);

  const [showDistributorModal, setShowDistributorModal] = useState(false);
  const [showPurchasePaymentModal, setShowPurchasePaymentModal] =
    useState(false);

  const [products, setProducts] = useState([]);
  const [billId, setBillId] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showCreateProductModal, setShowCreateProductModal] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productBarcode: "",
    hsn: "",
    batch: "",
    expiry: "",
    pack: "1 x",
    qty: "",
    free: "",
    mrp: "",
    rate: "",
    scheme: "",
    schemeBonus: "",
    schPercent: "",
    disc: "",
    gst: "",
    margin: "",
    amount: 0,
  });

  const handlePurchasePaymentSubmit = (paymentData) => {
    console.log("🧾 Purchase Payment Submitted:", paymentData);

    toast.success("Payment recorded successfully!", {
      position: "top-center",
      duration: 2500,
      style: { background: "#10b981", color: "#fff", fontWeight: 500 },
    });

    setShowPurchasePaymentModal(false);

    navigate("/PharmacyPurchase1", {
      state: { paymentSuccess: true, paymentData },
    });
  };

  const formik = useFormik({
    initialValues: {
      purchaseType: "Invoice",
      billHasGST: "Yes",
      distributerId: "",
      distributorName: "",
      invoiceNo: "",
      invoiceDate: "",
      paymentDueDate: "",
      overallDiscount: "",
      customCharge: "",
    },
    validationSchema: Yup.object({
      distributerId: Yup.string().required("Distributor is required"),
      invoiceNo: Yup.string().required("Invoice No is required"),
      invoiceDate: Yup.date().required("Invoice Date is required"),
      paymentDueDate: Yup.date().when("purchaseType", {
        is: "Invoice",
        then: (schema) => schema.required("Payment Due Date is required"),
      }),
    }),

    onSubmit: async (values) => {
      console.log("Formik submitted with values:", values);

      if (!values.distributerId) {
        toast.error("Please select a distributor before saving!", {
          position: "top-center",
          style: { background: "#ef4444", color: "#fff", fontWeight: 500 },
        });
        return;
      }

      if (products.length === 0) {
        toast.error("Please add at least one product before saving!", {
          position: "top-center",
          style: { background: "#ef4444", color: "#fff", fontWeight: 500 },
        });
        return;
      }

      try {
        const payload = {
          id: isEdit ? purchaseId : 0,

          pharmaId: PharmaId,
          billType: values.purchaseType,
          invoiceNum: String(values.invoiceNo),
          invoiceDate: values.invoiceDate,
          hasGST: values.billHasGST === "Yes",
          distributerId: String(values.distributerId),
          paymentDueDate: values.paymentDueDate,
          billDiscount: parseFloat(values.overallDiscountAmount) || 0,
          customCharge: 0,
          totalAmount: parseFloat(totals.totalAmount) || 0,
          paidAmount: 0,
          balanceAmount: parseFloat(totals.totalAmount) || 0,
          createdBy: "DEVELOPER",
          updatedBy: "DEVELOPER",
          isActive: true,

          products: products.map((p) => ({
            purProdId: p.purProdId || 0, 
            pharmaId: PharmaId,
            productId: p.productId || 0,
            batchId: String(p.batchId || ""),
            hsn: String(p.hsn || "NA"),
            expiry: p.expiry || "",
            mrp: parseFloat(p.mrp) || 0,
            rate: parseFloat(p.rate) || 0,
            numOfPacks: parseInt(p.pack) || 0,
            quantity: parseFloat(p.qty) || 0,
            isSampleFree: !!p.free,
            schemeName: p.scheme ? `${p.scheme}+${p.schemeBonus}` : "",
            schemeDiscPercent: parseFloat(p.schPercent) || 0,
            normalDiscPercent: parseFloat(p.disc) || 0,
            gstPercent: parseFloat(p.gst) || 0,
            marginPercent: parseFloat(p.margin) || 0,
            productAmount: parseFloat(p.amount) || 0,
            isActive: true,
          })),
        };

        console.log(" Final Payload:", payload);

        const response = await addPurchase(payload).unwrap();

        toast.success("Purchase saved successfully!", {
          position: "top-center",
          duration: 2500,
          style: { background: "#10b981", color: "#fff", fontWeight: 500 },
        });

        const billId = response?.pharmaPurchaseBillID;
        setBillId(billId);
        setShowPurchasePaymentModal(true);
      } catch (err) {
        console.error("❌ Error saving purchase:", err);
        toast.error("Failed to save purchase!", {
          position: "top-center",
          duration: 2500,
          style: { background: "#ef4444", color: "#fff", fontWeight: 500 },
        });
      }
    },
  });

  const calculateTotals = () => {
    const subtotal = products.reduce(
      (sum, p) => sum + (parseFloat(p.amount) || 0),
      0
    );

    const overallDiscPercent =
      parseFloat(formik.values.overallDiscountPercent) || 0;
    const discount = (subtotal * overallDiscPercent) / 100;

    const taxableAmount = subtotal - discount;

    const gstAmount = products.reduce((sum, p) => {
      const productGst =
        ((parseFloat(p.amount) || 0) * (parseFloat(p.gst) || 0)) / 100;
      return sum + productGst;
    }, 0);

    // Optional custom charge (delivery)
    const customChargeAmount = parseFloat(formik.values.customCharge) || 0;

    // Final total
    const totalAmount = taxableAmount + gstAmount + customChargeAmount;

    return {
      subtotal: Number(subtotal).toFixed(2),
      discount: Number(discount).toFixed(2),
      taxableAmount: Number(taxableAmount).toFixed(2),
      gstAmount: Number(gstAmount).toFixed(2),
      customChargeAmount: Number(customChargeAmount).toFixed(2),
      totalAmount: Number(totalAmount).toFixed(2),
      totalProducts: products.length,
      totalQuantity: products.reduce(
        (sum, p) => sum + (parseFloat(p.qty) || 0),
        0
      ),
    };
  };

  const totals = calculateTotals();

  const styles = `.add-new-purchase {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 20px;

.table-input {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 6px 10px;
  outline: none;
  transition: background 0.3s ease, color 0.3s ease;
}

/* Expired: Red background */
.table-input.expired {
  background-color: #ffcccc;
  border-color: #ff4d4d;
  color: #a10000;
}

/* Future expiry: Orange background */
.table-input.future {
  background-color: #ffe6cc;
  border-color: #ffa500;
  color: #663c00;
}


.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.back-arrow {
  cursor: pointer;
  color: #666;
}

.header h1 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.subtitle {
  color: #666;
  margin: 5px 0 0 0;
  font-size: 14px;
}

.header-right {
  display: flex;
  gap: 10px;
}

.watch-tutorial-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.save-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #5c6bc0;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.form-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-icon {
  color: #6c5ce7;
  margin-left: 5px;
  cursor: help;
}

.required {
  color: #e74c3c;
  font-size: 10px;
  font-weight: normal;
}

.radio-group {
  display: flex;
  gap: 15px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  cursor: pointer;
}

.radio-label input[type="radio"] {
  accent-color: #6c5ce7;
}

.form-input, .form-select {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #6c5ce7;
}

.date-input {
  position: relative;
}

.calendar-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
}

.status-indicators {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-bottom: 10px;
}

.status-indicator {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-indicator.expired {
  background: #e74c3c;
  color: white;
}

.status-indicator.expiring {
  background: #f39c12;
  color: white;
}

.products-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.products-table table {
  width: 100%;
  border-collapse: collapse;
}

.products-table th {
  background: #f8f9fa;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  text-transform: uppercase;
}

.products-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
}

.new-product-row {
  background: #f8f9fa;
}

.table-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

.table-input:focus {
  outline: none;
  border-color: #6c5ce7;
}

.add-btn {
  background: #5c6bc0;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
}

.edit-all-btn {
  background: transparent;
  border: none;
  color: #6c5ce7;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  text-transform: uppercase;
}

.product-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  font-size: 12px;
}

.status-dot.expired {
  color: #e74c3c;
}

.status-dot.expiring {
  color: #f39c12;
}

.expiry-warning {
  color: #f39c12;
  font-weight: 600;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.edit-icon, .delete-icon {
  cursor: pointer;
  color: #666;
}

.edit-icon {
  color: #6c5ce7;
}

.delete-icon {
  color: #e74c3c;
}

.bottom-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.discount-charge-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  gap: 20px;
}

.save-payment-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666;
}

.totals-bar {
  background: #2c3e50;
  color: white;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}

.totals-left {
  display: flex;
  gap: 30px;
  font-size: 14px;
}

.totals-right {
  display: flex;
  gap: 20px;
  aign-items: center;
  font-size: 14px;
}

.total-amount {
  background: #2f9c59ff;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 16px;
}
  /* Add these additional styles to your existing CSS */

.save-edit-btn {
  background: #28a745;
  border: none;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-edit-btn {
  background: #dc3545;
  border: none;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.edit-icon, .delete-icon {
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.edit-icon {
  color: #6c5ce7;
}

.edit-icon:hover {
  background-color: #f0f0f0;
}

.delete-icon {
  color: #e74c3c;
}

.delete-icon:hover {
  background-color: #ffebee;
}

.table-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

.table-input:focus {
  outline: none;
  border-color: #6c5ce7;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
}

.product-row.editing {
  background-color: #f8f9fa;
}

 .scheme-input-container {
          display: flex;
          align-items: center;
          gap: 2px;
          background: white;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 2px 4px;
          font-size: 13px;
          min-width: 80px;
        }

        .scheme-input-container:focus-within {
          border-color: #6c5ce7;
          box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
        }

        .scheme-base-input {
          border: none;
          outline: none;
          width: 30px;
          text-align: center;
          padding: 2px;
          background: transparent;
          font-size: 13px;
          color: #333;
        }

        .scheme-bonus-input {
          border: none;
          outline: none;
          width: 30px;
          text-align: center;
          padding: 2px;
          background: transparent;
          font-size: 13px;
          color: #333;
        }

        .scheme-display {
          display: flex;
          align-items: center;
          gap: 2px;
          font-size: 13px;
          color: #333;
          padding: 4px;
        }

        .scheme-percentage-display {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: #333;
          background: #f8f9fa;
          padding: 6px 8px;
          border-radius: 4px;
          border: 1px solid #e9ecef;
          min-width: 60px;
          font-weight: 500;
        }

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .save-edit-btn, .cancel-edit-btn {
    padding: 6px 10px;
  }
}


@media (max-width: 768px) {
  .add-new-purchase {
    padding: 10px;
  }
  
  .header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .header-right {
    width: 100%;
    justify-content: flex-end;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .products-table {
    overflow-x: auto;
  }
  
  .bottom-section {
    grid-template-columns: 1fr;
  }
  
  .totals-bar {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .totals-left, .totals-right {
    flex-wrap: wrap;
    justify-content: center;
  }
}
`;

  return (
    <>
      <style>{styles}</style>

      <div className="add-new-purchase">
        <div className="header">
          <div className="header-left">
            <button type="button" onClick={() => navigate(-1)}>
              <ArrowLeft className="back-arrow" size={24} />
            </button>
            <div>
              <h1>{isEdit ? "Edit Purchase" : "Add New Purchase"}</h1>
              <p className="subtitle">
                Fill in the details below to import a new purchase bill
              </p>
            </div>
          </div>
          <div className="header-right">
            <button
              type="button"
              onClick={formik.handleSubmit}
              disabled={isLoading}
              className="gradient-button"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                opacity: isLoading ? 0.7 : 1,
              }}
            >
              <Save size={16} /> {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>

        {/* 🔹 Formik handles form */}
        <form onSubmit={formik.handleSubmit}>
          <PurchaseForm
            formik={formik}
            setShowDistributorModal={setShowDistributorModal}
          />
          <ProductTable
            products={products}
            setProducts={setProducts}
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            onShowProductModal={() => setShowProductModal(true)}
            overallDiscountPercent={formik.values.overallDiscountPercent}
          />
          <DiscountChargeSection formik={formik} subtotal={totals.subtotal} />

          <TotalsBar totals={totals} />

          {/* <div className="form-footer" style={{ textAlign: "right", marginTop: "20px" }}>
            <button className="gradient-button" type="submit">
              <Save size={16} /> Save Purchase
            </button>
          </div> */}
        </form>

        {/* 🔹 Product Modal (gets data from parent) */}
        <ProductSelectModal
          open={showProductModal}
          onClose={() => setShowProductModal(false)}
          onSelect={(product) => {
            setNewProduct((prev) => ({
              ...prev,
              productId: product.productID,
              productBarcode: product.productName,
              mrp: product.mrp,
              rate: product.saleRate || "",
              hsn: product.hsn || "",
              pack: product.pack || "",
            }));
            setShowProductModal(false);
          }}
          onCreateNew={() => {
            setShowProductModal(false);
            setShowCreateProductModal(true);
          }}
        />

        {/* 🔹 Create Product Modal */}
        <CreateNewProduct
          show={showCreateProductModal}
          onClose={() => {
            setShowCreateProductModal(false);
            setShowProductModal(true);
          }}
          onAddProduct={(newProduct) => {
            setProducts([newProduct, ...products]);
            setShowCreateProductModal(false);
          }}
        />
        <DistributorSelectModal
          show={showDistributorModal}
          onHide={() => setShowDistributorModal(false)}
          onSelect={(dist) => {
            formik.setFieldValue("distributerId", dist.distributorId);
            formik.setFieldValue("distributorName", dist.distributorName);

            toast.success(`Distributor "${dist.distributorName}" selected!`, {
              position: "top-center",
              duration: 1500,
              style: { background: "#10b981", color: "#fff", fontWeight: 500 },
            });

            setShowDistributorModal(false);
          }}
        />

        <PurchasePaymentModal
          show={showPurchasePaymentModal}
          onHide={() => setShowPurchasePaymentModal(false)}
          totalPayable={totals.totalAmount}
          onSubmit={handlePurchasePaymentSubmit}
          distributorName={formik.values.distributorName}
          invoiceNum={formik.values.invoiceNo}
          invoiceDate={formik.values.invoiceDate}
          billId={billId}
        />
      </div>
    </>
  );
};

export default PurchaseOrder;
